export default __webpack_public_path__ + "static/media/logo-header-scotia-wealth-management.3c5f7d7c.svg";